import { BaseController } from 'controllers/BaseController'
import { OnRequestChangeCallback } from 'services/APIs/BaseAPI'
import {
  GetSelectablePaymentTermsResponse,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { InternalAPI } from 'services/APIs/InternalAPI/InternalAPI'
import { GetContext } from 'store/storeUtils'

export interface IPaymentTermsAPI {
  getSelectablePaymentTerms: () => Promise<GetSelectablePaymentTermsResponse>
}

class PaymentTermsAPI extends InternalAPI implements IPaymentTermsAPI {
  constructor(partyId: string, onRequestChange: OnRequestChangeCallback) {
    super(`/api/parties/${partyId}/paymentterms`, onRequestChange)
  }

  async getSelectablePaymentTerms() {
    return this.GetAsync<GetSelectablePaymentTermsResponse>({
      id: 'getSelectablePaymentTerms',
      relativePath: '/selectable',
    })
  }
}

export class PaymentTermsController extends BaseController<IPaymentTermsAPI> {
  constructor() {
    super((onRequestChange: OnRequestChangeCallback) => {
      const { partyId } = GetContext()
      return new PaymentTermsAPI(partyId, onRequestChange)
    })
  }

  async getSelectablePaymentTerms() {
    try {
      return await this.api.getSelectablePaymentTerms()
    } catch (err) {
      throw this.HandleError(err)
    }
  }
}
